import { api, headers } from "./api";

const RESOURCE = "usulan_tambahan_pencairan";

export const indexUsulanTambahanPencairan = (jadwal_id) =>
  api.get(RESOURCE + "?jadwal_id=" + jadwal_id, headers);

export const postCairkanUsulanLuaranTambahan = (id) =>
  api.post(RESOURCE + "/cairkan/" + id, {}, headers);

export const postValidasi = (id, data) =>
  api.post(RESOURCE + "/validasi/" + id, data, headers);
